var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [(_vm.isVisible)?_c('v-btn',_vm._g({staticClass:"mb-2",attrs:{"small":"","icon":"","color":"green white--text"},on:{"click":_vm.fetchDoc}},on),[_c('v-icon',[_vm._v("file_open")])],1):_vm._e()]}}])},[_vm._v(" Certificado Convenio ")])
}
var staticRenderFns = []

export { render, staticRenderFns }